import(/* webpackMode: "eager" */ "/vercel/path0/app/widget/page.tsx");
